import { PARAM_MEMBER_ID } from './constants';

export const buildLink = (template, memberId) => template.replace(PARAM_MEMBER_ID, memberId);
